import { AuthRequiredError } from 'shared/errors';

interface IParams {
  message?: string;
  errors?: object[];
}

export const assertAuthRequiredError = (domain: string, { message, errors }: IParams) => {
  return new AuthRequiredError({
    domain,
    message: message || '',
    details: {
      errors: JSON.stringify(errors),
    },
  });
};
